import React from "react";
import HeaderProfile from "../layout/HeaderProfile";
import HeaderAdmin from "../layout/HeaderAdmin";

import krezco from "../static/images/krezco-logo-footer.png";
import { Redirect } from 'react-router-dom'
import { Toaster } from "react-hot-toast";

const Layout = ({ children, profile, rol, unreadNotificationCount }) => {
  function getHeader() {
    switch (rol) {  
      case "applicant":
        return  <HeaderProfile profile={profile} rol={rol} unreadNotificationCount={unreadNotificationCount}></HeaderProfile>
      case "company":
        return <HeaderProfile profile={profile} rol={rol} unreadNotificationCount={unreadNotificationCount}></HeaderProfile>
            
      case "institute":
        return <HeaderProfile profile={profile} rol={rol} unreadNotificationCount={unreadNotificationCount}></HeaderProfile>
      
      case "admin":
        return <HeaderAdmin />
      default:
        return <Redirect to="/"/>
    }
  }
  return (
    <div className="profile">
        <Toaster />
        {getHeader()}
        {children}
        <Footer />
    </div>
  )
};

export const Footer = () => {
  return (
    <footer className="footer__backend mt5">
      <div className="container">
        <div className="row align-items-md-center">
          <div className="col-12 col-md-6">
            <div className="footer__backend--left">
              <div className="footer__backend-logo">
                <img src={krezco} alt="krezco" />
              </div>
              <div className="footer__backend-copy">
                <p>
                  &copy; 2021 KREZCO. Todos los derechos reservados |{" "}
                  <a href="/">Privacidad</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="footer__backend--right">
              <div className="footer__backend-search">
                <form>
                  <input
                    type="search"
                    placeholder="Buscar"
                    aria-label="Search"
                  />
                </form>
              </div>
              <div className="footer__backend-menu">
                <ul>
                  <li>
                    <a href="/Sobrenosotros">Sobre Nosotros</a>
                  </li>
                  <li>
                    <a href="/">Candidatos</a>
                  </li>
                  <li>
                    <a href="/Formacion">Formación</a>
                  </li>
                  <li>
                    <a href="/Empresas">Empresas</a>
                  </li>
                  <li>
                    <a href="/Teayudamos">¡Te ayudamos!</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Layout;
